export const SOURCE_URL_MAX_LENGTH = 2048;

const PUBLIC_HTTPS_URL = /^https:\/\/(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}|(?:(?:25[0-5]|2[0-4]\d|1?\d?\d)\.){3}(?:25[0-5]|2[0-4]\d|1?\d?\d))(?::\d+)?(?:\/\S*)?$/i;

export function isValidSourceUrl(raw: string): boolean {
	const value = raw.trim();
	if (value.length < 1 || value.length > SOURCE_URL_MAX_LENGTH) return false;
	return PUBLIC_HTTPS_URL.test(value);
}
